<template>
    <tr>
        <td>
            <span class="d-inline-block text-truncate" style="max-width: 90px;">
            {{ prospect.url }}
            </span>
        </td>
        <td class="col15">
            <b-overlay :show="show" rounded="sm">
                <b-form-select
                    :options="options"
                    v-model="prospect.assigned_id"
                    value-field="id"
                    text-field="title"
                    @change="save">
                </b-form-select>
            </b-overlay>
        </td>
        <td class="col25">
            <b-overlay :show="show" rounded="sm">
                <div class="row">
                    <app-input
                        name="company_name"
                        placeholder="Company name"
                        :value="prospect.company_name"
                        v-model="prospect.company_name"
                    ></app-input>
                    <app-button type="success" @click="save">
                        Save
                    </app-button>
                </div>
            </b-overlay>
        </td>
        <td>{{ prospect.users_count }}</td>
        <td>{{ prospect.courses_count }}</td>
        <td>{{ prospect.instructors_count }}</td>
        <td>{{ prospect.admins_count }}</td>
        <td>{{ formatDate(prospect.created_at) }}</td>
    </tr>
</template>

<script>
export default {
    props: {
        options: Array,
        initialProspect: Object,
    },
    data() {
        return {
            prospect: this.initialProspect,
            show: false
        };
    },
    methods: {
        save() {
            let data = {
                assigned_id: this.prospect.assigned_id,
                partner_id: this.prospect.partner_id,
                company_name: this.prospect.company_name,
                status: this.prospect.status
            };

            this.show = true;
            axios.put(route('prospects.update', this.prospect.id), data)
                .then(() => {
                    this.show = false;
                })
                .catch(() => {
                    this.show = false;
                });
        },
        formatDate(timestamp) {
            return dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss');
        }
    }
}
</script>
